<template>
  <AppPage class="works">
    <WorksGrid :projects="works.data.works" />
    <AppFooter :page="'works'" />
  </AppPage>
</template>

<script setup>
const isLoaded = useAppLoaded();
const brandRow = useBrandRow();
const prismic = usePrismic();
const { $gsap: gsap } = useNuxtApp();
const { data: works } = await useAsyncData('works', () =>
  prismic.client.getSingle('works')
);

definePageMeta({
  pageTransition: {
    name: 'page',
    mode: 'out-in',
  },
});

useSeoMeta({
  title: `Works | ${meta.titleShort}`,
  ogTitle: meta.title,
  description: meta.description,
  ogDescription: meta.description,
});

watch(
  () => isLoaded.value,
  () => {
    if (isLoaded.value) {
      gsap.delayedCall(0.5, () => {
        brandRow.value = 'top';
      });
    }
  },
  { immediate: true }
);
onMounted(() => {
  if (!isLoaded.value) return;
  brandRow.value = 'top';
});
</script>

<style lang="scss" scoped>
.works {
  padding-top: var(--top-offset);
}
</style>
